const value = {
    join: {
      title: 'Invitation to the project',
      welcome: 'Welcome to the project',
      toRole: 'You are a {{role}}.',
      eduDescription:
        'Here you will learn how to develop it securely. We will mark units that will help in the work and leave only those that are necessary based on your role',
      reqDescription:
        'Here are the requirements that will help you develop it safely. All that remains is to choose a role to indicate your area of ​​responsibility',
      reqEduDescription:
        'Here you will learn how to develop it securely. The selected requirements will guide you on what to consider, while the training materials will assist with implementation. Your area of responsibility will be defined based on your project role',
      youAreInProject: 'You are in the project',
      joinBtn: 'Join',
      errorDuringJoining: 'Error during joining the project',
      invitationNotFound: 'Invitation not found',
    },
  };

export default value;
